interface DocumentCardPreviewProps {
  content: string;
}

export function DocumentCardPreview({ content }: DocumentCardPreviewProps) {
  return (
    <div className="mt-2">
      <p className="text-sm text-muted-foreground line-clamp-2">
        {content}
      </p>
    </div>
  );
}